import React from 'react';
import { Box, Flex, Icon, Text, VStack } from '@chakra-ui/react';
import { MdHourglassTop } from 'react-icons/md';

/** Soft card used across admin lists / detail panes. */
export function AppCard({ children, ...props }) {
  return (
    <Box
      bg="bg.surface"
      borderWidth="1px"
      borderColor="border.subtle"
      borderRadius="md"
      p={5}
      {...props}
    >
      {children}
    </Box>
  );
}

/** Matches mobile verification status cards (pending amber / rejected soft red). */
export function StatusAlertCard({
  title = 'Verification pending',
  body,
  footer,
  icon = MdHourglassTop,
  variant = 'pending',
}) {
  const isError = variant === 'error';
  return (
    <Box
      w="100%"
      p={5}
      bg={isError ? 'bg.errorTint' : 'bg.amberTint'}
      borderWidth="1px"
      borderColor={isError ? 'status.error' : 'utkarsh.amber'}
      borderRadius="md"
    >
      <Flex align="center" gap={3} mb={3}>
        <Flex
          w="40px"
          h="40px"
          align="center"
          justify="center"
          borderRadius="12px"
          bg={isError ? 'status.error' : 'utkarsh.amber'}
          color={isError ? 'white' : 'utkarsh.ink'}
        >
          <Icon as={icon} boxSize={5} />
        </Flex>
        <Text fontSize="16px" fontWeight="700" color="text.primary">
          {title}
        </Text>
      </Flex>
      {body ? (
        <Text fontSize="14px" color="text.primary" lineHeight="1.45" mb={footer ? 2.5 : 0}>
          {body}
        </Text>
      ) : null}
      {footer ? (
        <Text
          fontSize="13px"
          color="text.secondary"
          lineHeight="1.4"
          whiteSpace="pre-wrap"
        >
          {footer}
        </Text>
      ) : null}
    </Box>
  );
}

/** Compact single-line pending/warning strip (even border, no left accent bar). */
export function InlineWarning({ children, ...props }) {
  return (
    <Box
      w="100%"
      px={3}
      py={2.5}
      bg="bg.amberTint"
      borderWidth="1px"
      borderColor="utkarsh.amber"
      borderRadius="md"
      {...props}
    >
      <Text fontSize="13px" fontWeight="600" color="text.primary" lineHeight="1.35">
        {children}
      </Text>
    </Box>
  );
}

export function UploadTile({ label = 'Upload', onClick }) {
  return (
    <VStack
      as="button"
      type="button"
      onClick={onClick}
      w="100%"
      minH="120px"
      justify="center"
      spacing={2}
      bg="bg.input"
      borderWidth="1px"
      borderColor="border.subtle"
      borderRadius="sm"
      color="text.primary"
      cursor="pointer"
      sx={{ '& > *': { pointerEvents: 'none' } }}
      _hover={{ borderColor: 'utkarsh.amber' }}
    >
      <Text fontSize="24px" fontWeight="500" lineHeight="1">
        +
      </Text>
      <Text fontSize="13px" fontWeight="600">
        {label}
      </Text>
    </VStack>
  );
}
